import { APP_CONFIG } from "../config";
import store from "../redux/store";
import axios from "axios";
import {
  getSasToken,
  loadingStart,
  loadingStop,
  customerUploadLogo,
  customerRemoveLogo,
  customerSelect
} from "../redux/actions";

const azure = axios.create({
  baseURL: APP_CONFIG.azureStorageAccount,
  responseType: "json"
});

export const storeLogo = (type, customerId, file, data, customer, mode) => {
  store.dispatch(loadingStart);
  store.dispatch(getSasToken(customerId)).then(response => {
    const { container, folder, sastoken } = response.payload.data;

    azure
      .put(
        `${container}/${folder ? `${folder}/` : "logo/"}${
          file.name
        }${sastoken}`,
        data,
        {
          mode: "no-cors",
          headers: {
            "content-type": file.type,
            "x-ms-blob-type": "BlockBlob"
          }
        }
      )
      .then(response => {
        customer.logopath = `${container}/${folder ? `${folder}/` : "logo/"}${
          file.name
        }`;
        store
          .dispatch(customerUploadLogo(type, customerId, customer))
          .then(response => {
            (mode === "edit" || mode === "addOrganisationLogo") &&
              store.dispatch(customerSelect(customerId));
            store.dispatch(loadingStop);
          });
        return response.status;
      });
  });
};

export const removeLogo = (type, customerId) => {
  store.dispatch(loadingStart);
  store.dispatch(customerRemoveLogo(type, customerId)).then(response => {
    store.dispatch(customerSelect(customerId));
    store.dispatch(loadingStop);
  });
};

export const getLogo = (customerId, customer) => {
  return new Promise((resolve, reject) => {
    store.dispatch(loadingStart);
    store.dispatch(getSasToken(customerId)).then(response => {
      const { sastoken } = response.payload.data;
      azure
        .get(`${customer.logopath}${sastoken}`, {
          responseType: "stream"
        })
        .then(response => {
          store.dispatch(loadingStop);
          resolve(response);
        });
    });
  });
};

export const getWiremapImage = (url, result) => {
  return new Promise((resolve, reject) => {
    store.dispatch(loadingStart);

    azure
      .get(`${url}${result.imagedata.sastoken}`, {
        responseType: "stream"
      })
      .then(response => {
        store.dispatch(loadingStop);
        resolve(response);
      });
  });
};

export const getLogoPath = (customerId, customer) => {
  return new Promise((resolve, reject) => {
    store.dispatch(getSasToken(customerId)).then(response => {
      const { sastoken } = response.payload.data;
      resolve(
        `${APP_CONFIG.azureStorageAccount}/${customer.logopath}${sastoken}`
      );
    });
  });
};



// WEBPACK FOOTER //
// ./src/common/storage.js